var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _c(
      "div",
      {
        staticClass: "banner",
        staticStyle: { position: "relative", width: "100%" }
      },
      [
        _c("img", {
          staticStyle: { width: "100%" },
          attrs: { src: "/static/img/tradecloud.png", alt: "" }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "lucency-btn",
          on: {
            click: function($event) {
              _vm.register("trade")
            }
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34e4016f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e4016f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tradecloud/tradecloud.vue
// module id = null
// module chunks = 